// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5627":"27f44797","8570":"186371b6"}[chunkId] + ".chunk.css";
};